import type { AgentId } from '@/domain/shared/Brand'
import type { SessionService } from './SessionService'

const ACCESS_TOKEN_KEY = 'access_token'
const AGENT_ID_KEY = 'agent_id'
const EXPIRES_AT_KEY = 'expires_at'

/**
 * 会话服务的默认实现，直接与本地存储交互
 */
export class DefaultSessionService implements SessionService {
  constructor(private readonly storage: Storage) {}

  getAgentId(): AgentId | null {
    const agentId = this.storage.getItem(AGENT_ID_KEY)
    return (agentId as AgentId) || null
  }

  getAccessToken(): string | null {
    return this.storage.getItem(ACCESS_TOKEN_KEY)
  }

  getExpiresAt(): number | null {
    const rawValue = this.storage.getItem(EXPIRES_AT_KEY)
    if (!rawValue) {
      return null
    }

    const expiresAt = Number(rawValue)
    return Number.isFinite(expiresAt) ? expiresAt : null
  }

  setAccessToken(token: string): void {
    this.storage.setItem(ACCESS_TOKEN_KEY, token)
  }

  setExpiresAt(expiresAt: number): void {
    this.storage.setItem(EXPIRES_AT_KEY, String(expiresAt))
  }

  setAgentId(agentId: AgentId): void {
    this.storage.setItem(AGENT_ID_KEY, agentId)
  }

  clearSession(): void {
    this.storage.removeItem(ACCESS_TOKEN_KEY)
    this.storage.removeItem(AGENT_ID_KEY)
    this.storage.removeItem(EXPIRES_AT_KEY)
  }
}
